module.exports = __webpack_public_path__ + "img/zw.993c5517.png";